import R from 'ramda';
import {combineReducers} from "redux";
import {FORM_VISIBLE, FORM_SUCCESS, FIELD_CHANGED, FORM_PROCESSING, FORM_ERROR} from "./actions";

function custom(state = {visible: false, success: false, processing: false, error: '', data: {}}, action) {
    if (action.course != 'custom') return state;
    switch (action.type) {
        case FORM_VISIBLE:
            return {...state, visible: action.visible};
        case FORM_SUCCESS:
            return {...state, success: action.success};
        case FORM_PROCESSING:
            return {...state, processing: action.processing};
        case FORM_ERROR:
            return {...state, error: action.error};
        case FIELD_CHANGED:
            const data = R.reject(R.isEmpty, {...state.data, [action.field]: action.value});
            return {...state, data };
        default:
            return state;
    }
}

function bergen(state = {visible: false, success: false, processing: false, error: '', data: {}}, action) {
    if (action.course != 'bergen') return state;
    switch (action.type) {
        case FORM_VISIBLE:
            return {...state, visible: action.visible};
        case FORM_SUCCESS:
            return {...state, success: action.success};
        case FORM_PROCESSING:
            return {...state, processing: action.processing};
        case FORM_ERROR:
            return {...state, error: action.error};
        case FIELD_CHANGED:
            const data = R.reject(R.isEmpty, {...state.data, [action.field]: action.value});
            return {...state, data };
        default:
            return state;
    }
}


export const reducers = combineReducers({custom, bergen});


// WEBPACK FOOTER //
// ./src/custom_course/reducers.js